import React, { Component } from "react";
import ReactExport from "react-export-excel";
import { map, isEmpty } from "lodash"
import {
    MDBBreadcrumb,
    MDBBreadcrumbItem,
    MDBCard,
    MDBCardBody,
    MDBTable,
    MDBBtn,
} from "mdbreact";
import CurrencyFormat from "react-currency-format";
import LoadingSpinner from "../components/components/LoadingSpinner";
import { showYesNoConfirm } from "../helper/AlertHelper";


class Report_wawancara_pusat_detail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data_student: "",
            is_show: false,
            data: "",
            totalUpp: 0,
            totalSpp: 0,
            rataUpp: 0,
            titlePayment: '',
            reportData: [],
            listMaster: {},
            listNonRutin: [],
            listRutin: [],
            rataSpp: 0,
            isLoading: true,
            isBtndelete: false,
            isShowHeaderReturn: false,
        };
    }

    getMaster(id = '', table) {
        var array = this.state.listMaster[table];
        var arrayfilter = array.filter((data) => { if (data.id === parseInt(id)) return data });
        var name = arrayfilter.length > 0 ? arrayfilter[0].name : '';
        return name;
    }

    getMasterBeforeState(id = 0, table) {
        var array = JSON.parse(localStorage.getItem('DATA_PARAMETER'))[table];
        var arrayfilter = array.filter((data) => { if (data.id == id) return data });
        var name = arrayfilter.length > 0 ? arrayfilter[0].name : '';
        return name;
    }

    getTitlePayment() {
        var array = JSON.parse(localStorage.getItem('DATA_PARAMETER')).prm_payment_interview;
        var arrayfilter = array.filter((data) => { if (data.is_routine === 0) return data });
        var name = arrayfilter.length > 0 ? arrayfilter[0].name : '';
        return name;
    }

    getTotalUpp(array = []) {
        let total = 0;
        if (array.length > 0) {
            map(array, (data) => {
                if (data.is_routine === '0' || data.is_routine === 0) {
                    data.nominal = data.nominal ? parseFloat(data.nominal) : parseFloat(data.value);
                    //hitung jumlah potongan
                    if (data.discount > 0 && data.discount !== null) {
                        data.potongan = parseFloat(data.discount);
                    } else {
                        data.potongan = 0;
                    }

                    //hitung total bayar
                    data.ttl = parseFloat(data.nominal) - parseFloat(data.potongan);
                    if (data.is_dp == 1) {
                        data.dp = data.dp ? data.dp : 0;
                        data.ttl_bayar = parseFloat(data.ttl) - parseFloat(data.dp);
                    } else {
                        data.ttl_bayar = parseFloat(data.ttl)
                    }
                    total = data.ttl_bayar;
                }
            })
        }
        return total;
    }

    getTotalSpp(array = []) {
        let total = 0;
        if (array.length > 0) {
            map(array, (data) => {
                if (data.is_routine === 1 || data.is_routine === '1') {
                    data.nominal = data.nominal ? parseFloat(data.nominal) : parseFloat(data.value);
                    total += data.nominal
                }
            })
        }
        return total;
    }

    getNominalNonRutin(listInterview, idNonRutin) {
        let value = 0;
        let dataInterview = listInterview.filter((data) => { if (data.id === idNonRutin) return data });
        let discount = 0;
        if (dataInterview.length > 0) {
            let interview = dataInterview[0];
            let nominal = interview.nominal ? parseInt(interview.nominal) : 0;
            if (interview.potongan_percent !== 0) {
                if (interview.tipe_potongan === 0) {
                    discount = (nominal * interview.potongan_percent) / 100;
                } else {
                    discount = interview.potongan_percent;
                }
            }
            if (interview.uniq_discount.length > 0) {
                interview.uniq_discount.map((data) => {
                    if (data.tipe_discount === 0) {
                        discount += (nominal * data.value_discount) / 100;
                    } else {
                        discount += data.value_discount;
                    }
                })
            }
            value = nominal - discount;
        }
        return value;
    }

    getTotalNonRutin(idNonRutin) {
        let total = 0;
        let listReport = this.state.reportData;
        listReport.map((data) => {
            total += this.getNominalNonRutin(data.interview_result, idNonRutin);
        })
        return total;
    }

    getRataNonRutin(idNonRutin) {
        let rata = 0;
        let total = this.getTotalNonRutin(idNonRutin);
        rata = total / this.state.reportData.length;
        return rata.toFixed(0);
    }

    renderBtnDelete = (item) => {
        if (this.state.isBtndelete && item.flow_id === 'FIN') {
            return (
                <>
                    <td>
                        <button
                            onClick={() => this.onClickKembali(item)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#dc2626",
                                color: "white",
                                padding: "8px",
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                                width: "36px",
                                height: "36px",
                            }}
                            title="Kembali"
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
                            </svg>
                        </button>
                    </td>
                </>
            );
        } else {
            return (<><td></td></>);
        }
    }

    renderBtnReject = (data) => {
        // if (data.flow_id === 'DIS') {
        if (!this.state.isShowHeaderReturn) {
            this.setState({ isShowHeaderReturn: true });
        }
        return (
            <>
                <td>
                    <button
                        onClick={() => this.onClickReturn(data)}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#f59e0b",
                            color: "white",
                            padding: "8px",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            width: "36px",
                            height: "36px",
                            textDecoration: "underline",
                        }}
                        title="Dikembalikan"
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                        </svg>
                    </button>
                </td>
            </>
        );
        // }
    }

    onClickKembali = (item) => {
        const form_data = new FormData();
        form_data.append("id", item.id);
        form_data.append('subdomain', item.subdomain);
        fetch(global.variable.LINK_API + "student/back-flow", {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + global.cookies.get("access_token"),
            },
            body: form_data,
        })
            .then((response) => response.json())
            .then((resData) => {
                if (resData.code === 200) {
                    global.swal("Berhasil", resData.message, "success");
                    this.componentDidMount();
                } else {
                    global.swal("Info", resData.message, "info");
                }
            });
    }

    onClickReturn = async (data) => {
        const res = await showYesNoConfirm(
            "Anda yakin mengembalikan siswa ini?",
            data.fullname + " akan dikembalikan ke status wawancara. Yakin?",
            "warning",
            "Ya",
            "Tidak",
        );

        if (res == null) {
            return;
        }
        if (res.dismiss) {
            return;
        }
        if (res.value) {
            this.setState({ isLoading: true });
            fetch(global.variable.LINK_API + 'student/cancel-rejected-interview',
                {
                    method: 'post',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        'Authorization': 'Bearer ' + global.cookies.get('access_token'),
                    },
                    body: JSON.stringify({ id: data.id, subdomain: data.subdomain }),
                },
            )
                .then(response => response.json())
                .then(resData => {
                    this.setState({ isLoading: false });
                    if (resData.message === "Success") {
                        global.swal("Success", resData.message, "success",);
                        window.location.reload();
                    } else {
                        global.swal("Error", resData.message, "info")
                    }
                });
        }
    }

    checkUserAccess = async () => {
        const levelId = localStorage.getItem('levels_id');
        await fetch(global.variable.LINK_API + 'user/access', {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + global.cookies.get('access_token'),
            },
            body: JSON.stringify({ user_level_id: levelId, user_access_id: '2' }),
        })
            .then(response => response.json())
            .then(resData => {
                if (resData.code === 200) {
                    this.setState({ isBtndelete: resData.data });
                } else {
                    global.swal("Error", 'Gagal mengambil data akses user', "info");
                }
            });
    }

    async componentDidMount() {
        let data_report;
        var param = JSON.parse(localStorage.getItem('pusat_data'));
        var split = param.split('/');
        var unit = split[0];
        var year = split[1];

        this.setState({
            isLoading: true,
        })
        const formData = new FormData();
        formData.append('type', 'interview');
        formData.append('subdomain', unit);
        if (year !== '') {
            formData.append('year', year);
        }
        await fetch(global.variable.LINK_API + 'report/list-by-unit',
            {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    'Authorization': 'Bearer ' + global.cookies.get('access_token'),
                },
                body: formData,
            })
            .then(response => response.json())
            .then(resData => {
                if (resData.code === 200) {
                    data_report = resData.data;
                } else {
                    global.swal("Error", resData.message, "info")
                    return;
                }
            });

        this.checkUserAccess();

        let data = [];
        let total1 = 0;
        let total2 = 0;
        let rata = 0;
        let rataSpp = 0;
        let Data2 = [];
        let dataParam = JSON.parse(localStorage.getItem("DATA_PARAMETER"))
        let paramNonRutin = dataParam.prm_payment_interview.filter((data) => { if (parseInt(data.is_routine) === 0) return data });
        let paramRutin = dataParam.prm_payment_interview.filter((data) => { if (parseInt(data.is_routine) === 1) return data });

        data_report.map((datax) => {
            let items3 = Object.create({});
            const total = this.getTotalUpp(datax.interview_result);
            const totalNonRutin = this.getTotalSpp(datax.interview_result);
            let noteReject = '';
            datax.totalPaymentNotRoutine = total;
            datax.totalSPP = totalNonRutin;
            items3[`Nama Lengkap`] = datax.fullname;
            items3[`Nomor Pendaftaran`] = datax.year + "-" + datax.registration_number;
            items3[`Nomor Handphone`] = datax.hp;
            items3[`Status`] = this.getMasterBeforeState(datax.interview_status_id, 'pdf_interview_status');
            items3[`Pewawancara`] = datax.interview_name ? datax.interview_name : "Panitia PPDB";
            paramNonRutin.map((data) => {
                items3[data.name] = this.getNominalNonRutin(datax.interview_result, data.id);
            })
            items3['SPP'] = totalNonRutin;
            items3[`Catatan Tentang Pendaftar`] = datax.note_verification ? datax.note_verification : "";
            if (parseInt(datax.interview_status_id) === 3) {
                noteReject = datax.note_reject ? datax.note_reject : "";
            }
            items3[`Catatan Wawancara`] = noteReject;
            total1 += parseFloat(total);
            total2 += parseFloat(totalNonRutin);
            Data2.push(items3);
            return { ...datax };
        })

        rata = parseFloat(total1) / parseInt(data_report.length)
        rataSpp = parseFloat(total2) / parseInt(data_report.length)

        let items = Object.create({});
        items.fullname = "TOTAL";
        items.upp =
            "Rp" + total1.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        let items2 = Object.create({});
        items2.fullname = "Rata-Rata";
        items2.upp =
            "Rp" + rata.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        data.push(items2);

        this.setState(
            {
                report: Data2,
                totalUpp: total1,
                totalSpp: total2,
                rataUpp: rata,
                rataSpp: rataSpp,
                is_show: true,
                reportData: data_report,
                listMaster: JSON.parse(localStorage.getItem("DATA_PARAMETER")),
                titlePayment: this.getTitlePayment(),
                listNonRutin: paramNonRutin,
                listRutin: paramRutin,
                isLoading: false,
            },
        );
    }

    render() {
        let counter = 0;
        let paramNonRutin = this.state.listNonRutin.sort((a, b) => { return a.id - b.id });
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="divContainter">
                                    <MDBCard className="mb-5">
                                        <MDBCardBody>
                                            <MDBBreadcrumb color="cyan lighten-4">
                                                <MDBBreadcrumbItem active>
                                                    <a href="/home">Home</a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    Laporan Wawancara
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>
                                            {this.state.isLoading ? <LoadingSpinner /> : (
                                                <MDBTable>
                                                    <thead className="blue-grey lighten-4">
                                                        <tr>
                                                            <th>#</th>
                                                            <th width="100">Nama Lengkap</th>
                                                            <th width="100">Nomor Pendaftaran</th>
                                                            <th>Nomor Handphone</th>
                                                            <th>Status</th>
                                                            <th>Pewawancara</th>
                                                            {
                                                                paramNonRutin.map((item, idx) => {
                                                                    return <th>{item.name}</th>
                                                                })
                                                            }
                                                            <th>SPP</th>
                                                            {this.state.isBtndelete ? <th></th> : null}
                                                            {this.state.isShowHeaderReturn ? <th></th> : null}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.reportData.map((item, idx) => {
                                                            counter++;
                                                            return (
                                                                <tr key={idx}>
                                                                    <td>{counter}</td>
                                                                    <td>
                                                                        {item.fullname.toUpperCase()}
                                                                    </td>
                                                                    <td>
                                                                        {item.year +
                                                                            "-" +
                                                                            item.registration_number}
                                                                    </td>
                                                                    <td>{item.hp}</td>

                                                                    <td>
                                                                        {this.getMaster(item.interview_status_id, 'pdf_interview_status')}
                                                                    </td>
                                                                    <td>
                                                                        {item.interview_name
                                                                            ? item.interview_name
                                                                            : "Panitia PPDB"}
                                                                    </td>
                                                                    {
                                                                        paramNonRutin.map((dataNonRutin, idx) => {
                                                                            return (
                                                                                <td>
                                                                                    <CurrencyFormat
                                                                                        input="number"
                                                                                        prefix={"Rp. "}
                                                                                        readOnly
                                                                                        value={this.getNominalNonRutin(item.interview_result, dataNonRutin.id)}
                                                                                        maxLength="25"
                                                                                        thousandSeparator={true}
                                                                                        style={{ width: "100%" }}
                                                                                        displayType={"text"}
                                                                                    />
                                                                                </td>
                                                                            )
                                                                        })
                                                                    }
                                                                    <td>
                                                                        {item.totalSPP > 0 ? (
                                                                            <CurrencyFormat
                                                                                input="number"
                                                                                prefix={"Rp. "}
                                                                                readOnly
                                                                                value={item.totalSPP > 0 ? item.totalSPP : '0'}
                                                                                maxLength="25"
                                                                                thousandSeparator={true}
                                                                                style={{ width: "100%" }}
                                                                                displayType={"text"}
                                                                            />
                                                                        ) : 0}
                                                                    </td>
                                                                    {this.renderBtnDelete(item)}
                                                                    {this.renderBtnReject(item)}
                                                                </tr>
                                                            );
                                                        })}
                                                        <tr>
                                                            <td colSpan={6}>TOTAL </td>
                                                            {
                                                                paramNonRutin.map((dataNonRutin, idx) => {
                                                                    return (
                                                                        <td>
                                                                            <CurrencyFormat
                                                                                input="number"
                                                                                prefix={"Rp. "}
                                                                                readOnly
                                                                                value={this.getTotalNonRutin(dataNonRutin.id)}
                                                                                maxLength="25"
                                                                                thousandSeparator={true}
                                                                                style={{ width: "100%" }}
                                                                                displayType={"text"}
                                                                            />
                                                                        </td>
                                                                    )
                                                                })
                                                            }
                                                            <td>
                                                                <CurrencyFormat
                                                                    input="number"
                                                                    prefix={"Rp. "}
                                                                    readOnly
                                                                    value={this.state.totalSpp}
                                                                    maxLength="25"
                                                                    thousandSeparator={true}
                                                                    style={{ width: "100%" }}
                                                                    displayType={"text"}
                                                                />
                                                                &nbsp;
                                                            </td>
                                                            {this.state.isBtndelete ? <td></td> : null}
                                                            {this.state.isShowHeaderReturn ? <td></td> : null}
                                                        </tr>

                                                        <tr>
                                                            <td colSpan={6}>RATA-RATA</td>
                                                            {
                                                                paramNonRutin.map((dataNonRutin, idx) => {
                                                                    return (
                                                                        <td>
                                                                            <CurrencyFormat
                                                                                input="number"
                                                                                prefix={"Rp. "}
                                                                                readOnly
                                                                                value={this.getRataNonRutin(dataNonRutin.id)}
                                                                                maxLength="25"
                                                                                thousandSeparator={true}
                                                                                style={{ width: "100%" }}
                                                                                displayType={"text"}
                                                                            />
                                                                        </td>
                                                                    )
                                                                })
                                                            }
                                                            <td>
                                                                <CurrencyFormat
                                                                    input="number"
                                                                    prefix={"Rp. "}
                                                                    readOnly
                                                                    value={this.state.rataSpp.toFixed(0)}
                                                                    maxLength="25"
                                                                    thousandSeparator={true}
                                                                    style={{ width: "100%" }}
                                                                    displayType={"text"}
                                                                />
                                                            </td>
                                                            {this.state.isBtndelete ? <td></td> : null}
                                                            {this.state.isShowHeaderReturn ? <td></td> : null}
                                                        </tr>
                                                    </tbody>
                                                </MDBTable>
                                            )}

                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Report_wawancara_pusat_detail;
